import { SearchInput, usePostSearchController } from '@nucleus/post-theme-elements';
import { SkeletonBlock } from '@nucleus/web-theme-elements';
import { PostSearchRequestBlockWeb } from '@nucleus/types/web/sections/post-search-request';
import React, { useState } from 'react';
import styled from 'styled-components';
import { BlockProps } from '../types/component';
import { BlockInfo } from './BlockInfo';

type BlockPostSearchRequestProps = Extract<
  BlockProps,
  { block?: PostSearchRequestBlockWeb; sectionType?: 'postSearchRequest' }
>;

export const BlockPostSearchRequest = ({ block, ...props }: BlockPostSearchRequestProps): JSX.Element => {
  const { searchQuery, setSearchQuery } = usePostSearchController();
  const [queryValue, setQueryValue] = useState(searchQuery);

  const updateSearchQuery = (searchQuery: string) => {
    setQueryValue(searchQuery);
  };

  const submitSearchQuery = (searchQuery: string) => {
    setQueryValue(queryValue);
    setSearchQuery(queryValue);
  };
  return (
    <BlockInfo {...props} block={block}>
      <SearchInput
        searchQuery={queryValue}
        updateSearchQuery={updateSearchQuery}
        submitSearchQuery={submitSearchQuery}
      />
    </BlockInfo>
  );
};

export const BlockPostSearchRequestFallback = ({ block, ...props }: BlockPostSearchRequestProps): JSX.Element => {
  return (
    <BlockInfo {...props} block={block}>
      <SearchInputSkeleton />
    </BlockInfo>
  );
};

const SearchInputSkeletonContainer = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 24px;
  width: 508px;
  max-width: 100%;
`;

const SearchInputSkeletonInput = styled(SkeletonBlock)`
  flex: 1;
  height: 50px;
`;

const SearchInputSkeletonButton = styled(SkeletonBlock)`
  width: 100px;
  height: 50px;
`;

const SearchInputSkeleton = (): JSX.Element => {
  return (
    <SearchInputSkeletonContainer>
      <SearchInputSkeletonInput />
      <SearchInputSkeletonButton />
    </SearchInputSkeletonContainer>
  );
};
